import React, { Component } from 'react';
import endUserPreferences from './EndUser.preferences';
import Swal from 'sweetalert2';
import XLSX from 'xlsx';
import { Trans } from 'react-i18next';

import { withTranslation } from 'react-i18next';
import {
  Card,
  Icon,
  Search,
  Select,
  Button,
  IconDownload,
  Table,
} from '@veneer/core';
// import { Table, TableConfiguration } from '@veneer/table';
import ConnectAPI from '../../../services/api';
import moment from 'moment';
import { authenticationService } from '../../../services/context/AuthService';

class Report extends Component {
  constructor(props) {
    super(props);
    this.connectAPI = new ConnectAPI();
    const preferences = endUserPreferences;
    const paginationConfig = {
      currentPage: 1,
      totalItems: 50,
      pageSizeOptions: [25, 50, 100],
      pageSize: 100,
    };

    this.state = {
      data: [],
      filteredColumns: [],
      paginationConfig,
      endUsers: [],
      channels: [],
      loading: true,
      loadingExport: false,
      loadingEndUsers: true,
      customerId: 'whole',
      status: 'active',
      channelSelected: 'whole',
      channelsView: [],
      preferences,
      showClearAllFilters: false,
      order: [],
      config: [
        {
          id: 'endUserNameLink',
          label: <Trans i18nKey="Client" />,
          index: true,
          filter: (
            <Search
              id="client-search"
              //label="Type a Client"
              onChange={(value) =>
                this.handleSingleFilter({
                  column: 'endUserNameLink',
                  filterValue: value,
                })
              }
            />
          ),
        },
        {
          id: 'customerName',
          label: <Trans i18nKey="channel" />,
          filter: (
            <Search
              id="customer-name-search"
              onChange={(value) =>
                this.handleSingleFilter({
                  column: 'customerName',
                  filterValue: value,
                })
              }
            />
          ),
        },
        {
          id: 'serviceArea',
          label: <Trans i18nKey="Subregion" />,
          width: '100px',
          filter: (
            <Search
              id="service-area-search"
              onChange={(value) =>
                this.handleSingleFilter({
                  column: 'serviceArea',
                  filterValue: value,
                })
              }
            />
          ),
        },
        {
          id: 'country',
          label: <Trans i18nKey="Country" />,
          filter: (
            <Search
              id="country-search"
              onChange={(value) =>
                this.handleSingleFilter({
                  column: 'country',
                  filterValue: value,
                })
              }
            />
          ),
        },
        {
          id: 'status',
          label: <Trans i18nKey="Status" />,
          width: '80px',
        },
        {
          id: 'rebateImage',
          label: <Trans i18nKey="CPP Program" />,
          width: '80px',
        },
        {
          id: 'pressList',
          label: <Trans i18nKey="Presses" />,
          filter: (
            <Search
              id="pressList"
              onChange={(value) =>
                this.handleSingleFilter({
                  column: 'pressList',
                  filterValue: value,
                })
              }
            />
          ),
        },
        // {
        //   id: 'idEndUser',
        //   configurable: false,
        //   label: '',
        //   index: true,
        // },
      ],
      //selectionColumn: 'checkbox',
      //idColumn: 'idEndUser',
    };
  }

  componentDidMount() {
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));

    if (currentUser.idRole == 11 || currentUser.idRole == 12) {
      /*if (currentUser.idEndUser==null){
        //authenticationService.logout();
      }else{*/
        const { history } = this.props;
        history.push({
          pathname: '/cpp/report/' + currentUser.idEndUser
        });
      //}
      
    }
    this.setState({ order: this.state.config.map((c) => c.id) });
    this.getChannelsData();
    this.getEndUsersData(this.state.customerId, this.state.status);
  }

  getFilterValue = (columnName) => {
    const { filteredColumns } = this.state;
    const filteredColumn = filteredColumns.find(
      ({ column }) => column === columnName
    );
    if (filteredColumn) {
      return filteredColumn.filterValue;
    }
    return undefined;
  };

  setFilterValues = (config) => {
    const newConfig = config;
    const newColumns = newConfig.columns.map((column) => {
      const newColumn = column;
      if (newColumn.filter) {
        newColumn.filter.component = React.cloneElement(
          column.filter.component,
          {
            value: this.getFilterValue(column.column),
          }
        );
      }
      return newColumn;
    });
    newConfig.columns = newColumns;
    return newConfig;
  };

  sortData = (sortBy, dataToSort) => {
    let dataSorted;
    const { type, id } = sortBy;
    //console.log(sortBy);

    if (type === 'ascending') {
      dataSorted = dataToSort.sort((a, b) => {
        let value, x, y;
        //console.log(id);
        //console.log(a);
        //console.log(b);
        //console.log(a[id]);
        //console.log(b[id]);
        x =
          typeof a[id] === 'object'
            ? typeof a[id] === typeof (<a />)
              ? a[id].props.href
              : a[id].props.label
            : a[id];
        y =
          typeof b[id] === 'object'
            ? typeof b[id] === typeof (<a />)
              ? b[id].props.href
              : b[id].props.label
            : b[id];
        //console.log(x);
        //console.log(y);
        if (x?.toUpperCase() > y?.toUpperCase()) {
          value = 1;
        } else if (y?.toUpperCase() > x?.toUpperCase()) {
          value = -1;
        } else {
          value = 0;
        }

        return value;
      });
    } else {
      dataSorted = dataToSort.sort((a, b) => {
        let value, x, y;
        x =
          typeof a[id] === 'object'
            ? typeof a[id] === typeof (<a />)
              ? a[id].props.href
              : a[id].props.label
            : a[id];
        y =
          typeof b[id] === 'object'
            ? typeof b[id] === typeof (<a />)
              ? b[id].props.href
              : b[id].props.label
            : b[id];
        if (x?.toUpperCase() < y?.toUpperCase()) {
          value = 1;
        } else if (y?.toUpperCase() < x?.toUpperCase()) {
          value = -1;
        } else {
          value = 0;
        }
        return value;
      });
    }
    return dataSorted;
  };

  getData = () => {
    this.setState({ loading: true });

    setTimeout(() => {
      const { paginationConfig, preferences } = this.state;

      let pageData = this.state.endUsers;
      this.state.filteredColumns.forEach((filter) => {
        pageData = pageData.filter((row) =>
          row[
            filter.column === 'endUserNameLink' ? 'endUserName' : filter.column
          ]
            .toString()
            .toLowerCase()
            .includes(filter.filterValue.toLowerCase())
        );
      });
      pageData = this.sortData(preferences.sortBy, pageData);

      const { pageSize, currentPage } = paginationConfig;
      const initialIndex = (currentPage - 1) * pageSize;
      const finalIndex = currentPage * pageSize;
      paginationConfig.currentPage = currentPage;
      paginationConfig.totalItems = pageData.length;

      pageData = pageData.slice(initialIndex, finalIndex);

      this.setState({
        data: pageData,
        paginationConfig,
        loading: false,
      });
    }, 750);
  };

  changePageSize = (pageSize) => {
    const { paginationConfig } = this.state;
    paginationConfig.pageSize = pageSize;
    paginationConfig.currentPage = 1;
    this.setState({ paginationConfig }, () => this.getData());
  };

  changePage = (currentPage) => {
    const { paginationConfig } = this.state;
    paginationConfig.currentPage = currentPage;
    this.setState({ paginationConfig }, () => this.getData());
  };

  handleClearAllFilters = () => {
    this.setState(
      {
        filteredColumns: [],
        showClearAllFilters: false,
      },
      () => this.getData()
    );
  };

  handleSelect = (index) => {
    const { data } = this.state;
    const updatedData = data;
    updatedData[index].selected = true;

    this.setState({
      data: updatedData,
      selectAllItems: false,
    });
  };

  handleFilter = (filteredColumns) => {
    //console.log('handleFilter');
    const { paginationConfig } = this.state;
    paginationConfig.currentPage = 1;
    this.setState({ filteredColumns }, () => this.getData());
  };

  handleSingleFilter = (filteredColumn) => {
    const { filteredColumns, showClearAllFilters } = this.state;
    const indexOf = filteredColumns.findIndex(
      ({ column }) => column === filteredColumn.column
    );
    if (filteredColumn.filterValue) {
      if (indexOf === -1) {
        filteredColumns.push(filteredColumn);
        if (!showClearAllFilters) {
          this.setState({
            showClearAllFilters: true,
          });
        }
      } else {
        filteredColumns[indexOf] = filteredColumn;
      }
    } else if (indexOf !== -1) {
      filteredColumns.splice(indexOf, 1);
      if (filteredColumns.length === 0 && showClearAllFilters) {
        this.setState({
          showClearAllFilters: false,
        });
      }
    }
    this.handleFilter(filteredColumns);
  };
  handleOnColumnReorder = (newOrder) => {
    this.setState({ order: newOrder });
  };

  handleSort = (_, sortBy) => {
    //console.log(sortBy);
    const { preferences } = this.state;
    preferences.sortBy = sortBy;
    this.setState({ preferences }, () => this.getData());
  };

  handleChange = (updatedConfig) => {
    this.setState({ preferences: updatedConfig });
  };

  handleResize = (columnName, width) => {
    const { preferences } = this.state;
    const updatedPreferences = JSON.parse(JSON.stringify(preferences));
    updatedPreferences.widths[columnName] = width;
    this.setState({
      preferences: updatedPreferences,
    });
  };

  getChannelsData() {
    this.connectAPI
      .get('api/Channels', '', this.channelsLoad)
      .catch((error) => {
        if(error.response.status==510){
          authenticationService.logout();
        }else{
          //console.log(error);
          Swal.fire(
            'Error ' + error?.response?.status,
            error?.response?.data,
            'error'
          );
        }
        
      });
  }

  channelsLoad = (status, data) => {
    const items = data.map((item) => {
      return {
        value: item.idCustomer,
        label: item.name,
      };
    });

    this.setState({
      channels: data,
      loading: false,
      channelsView: items,
    });
  };

  getEndUsersData(customerId, status) {
    this.connectAPI
      .get(
        'api/Channels/endusers',
        {
          params: {
            customerId: customerId,
            status: status,
          },
        },
        this.endUsersLoad
      )
      .catch((error) => {
        this.setState({
          loadingEndUsers: false,
        });
        Swal.fire(
          'Error ' + error?.response?.status,
          error?.response?.data,
          'error'
        );
      });
  }

  endUsersLoad = (status, data) => {
    //console.log(data);

    const dataTable = data.map((item) => {
      item.endUserNameLink = (
        <a href={"/cpp/report/" + item.idEndUser}>
          {item.endUserName}
        </a>
      );

      if (item.rebateProgram) {
        item.rebateImage = 'Yes';
        // <LabeledIcon label="yes" color="green" name="enabled" size={24} />
        return item;
      }

      item.rebateImage = 'No';
      // <LabeledIcon label="no" color="red" name="inactive" size={24} />
      return item;
    });

    this.setState(
      {
        endUsers: dataTable,
        loadingEndUsers: false,
        data: dataTable,
      },
      () => this.getData()
    );
  };

  renderStatusList() {
    const handleStatusChange = (name) => (event) => {
      //console.log(event.value);
      this.setState({
        ...this.state,
        status: event.value,
        loadingEndUsers: true,
      });
      this.getEndUsersData(this.state.channelSelected, event.value);
    };

    return (
      <div
        style={{
          width: '200px',
        }}
      >
        <Select
          name="status"
          onChange={handleStatusChange()}
          options={[
            {
              value: 'active',
              label: <Trans i18nKey="active" />,
            },
            {
              value: 'inactive',
              label: <Trans i18nKey="inactive" />,
            },
          ]}
          value={[this.state.status]}
        ></Select>
      </div>
    );
  }

  renderChannelsList(channels) {
    const handleSelectChange = (name) => (event) => {
      const items = this.state.channels.map((data) => {
        return {
          value: data.idCustomer,
          label: data.name,
        };
      });

      const { paginationConfig } = this.state;
      paginationConfig.currentPage = 1;

      this.setState({
        ...this.state,
        channelSelected: event.value,
        channelsView: items,
        loadingEndUsers: true,
        paginationConfig,
      });

      this.getEndUsersData(event.value, this.state.status);
    };

    const handleClearChannel = (name) => (event) => {
      this.setState({
        ...this.state,
        channelSelected: 'whole',
      });

      this.getEndUsersData('whole', this.state.status);
    };

    const handleSearchChange = (name) => (value) => {
      const items = this.state.channels
        .filter((data) => {
          if (value == null) return data;
          else if (data.name.toLowerCase().includes(value.toLowerCase())) {
            return data;
          }
        })
        .map((data) => {
          var res = {
            value: data.idCustomer,
            label: data.name,
          };
          return res;
        });

      this.setState({
        ...this.state,
        channelsView: items,
      });
    };

    return (
      <div
        style={{
          width: '350px',
        }}
      >
        <Select
          name="channel"
          onChange={handleSelectChange()}
          onSearch={handleSearchChange()}
          onClear={handleClearChannel()}
          options={this.state.channelsView}
          placeholder={<Trans i18nKey="channels" />}
          showSearch={true}
          value={[this.state.channelSelected]}
        />
      </div>
    );
  }

  handleSelectReport = (index) => (event) => {
    event.preventDefault();
    const { history } = this.props;
    history.push({
      pathname: '/cpp/report/' + index.idEndUser,
      data: index,
    });
  };
  

  renderEndUsersTable() {
    const {
      config,
      data,
      order,
      preferences,
      loadingEndUsers,
      showClearAllFilters,
      paginationConfig,
    } = this.state;

    return (
      <div>
        <Table
          columnReorder
          // columns={this.setFilterValues(config)}
          columns={config}
          data={data}
          showFilters
          onColumnReorder={this.handleOnColumnReorder}
          preferences={{
            defaultOrder: config.map((c) => c.id),
            order,
            sortBy: {
              id: 'endUserNameLink',
              type: 'descending',
            },
          }}
          loading={loadingEndUsers}
          //mode="fixedHeight"
          //onClearAllFilters={this.handleClearAllFilters}
          //modeHeight={450}
          //onResize={this.handleResize}
          //onDeselect={this.handleDeselect}
          //onFilter={this.handleFilter}
          onSort={this.handleSort}
          //stretchColumnStyle
          //showClearAllFilters={showClearAllFilters}
          pagination={{
            currentPage: paginationConfig.currentPage,
            pageSize: paginationConfig.pageSize,
            totalItems: paginationConfig.totalItems,
            onPageChange: this.changePage,
          }}
        >
          {/* <Pagination
            currentPage={paginationConfig.currentPage}
            onChangePageSize={this.changePageSize}
            onPaginate={this.changePage}
            pageSize={paginationConfig.pageSize}
            pageSizeOptions={paginationConfig.pageSizeOptions}
            totalItems={paginationConfig.totalItems}
          /> */}
        </Table>
        <div style={{ textAlign: 'left' }}>
          <Button
            leadingIcon={<IconDownload />}
            onClick={() => {
              this.exportData();
            }}
            disabled={this.state.endUsers.length === 0}
            loading={this.state.loadingExport}
            title="Download Data"
          >
            <Trans i18nKey='download'/>
          </Button>
          {/* <TableConfiguration
            columns={config.columns}
            disableResetToDefault
            onChange={this.handleChange}
            preferences={preferences}
          /> */}
        </div>
      </div>
    );
  }

  exportData = () => {
    this.setState({ loadingExport: true });
    setTimeout(() => {
      let data = this.state.endUsers;
      this.state.filteredColumns.forEach((filter) => {
        data = data.filter((row) =>
          row[
            filter.column === 'endUserNameLink' ? 'endUserName' : filter.column
          ]
            .toString()
            .toLowerCase()
            .includes(filter.filterValue.toLowerCase())
        );
      });
      //const data = this.state.endUsers;
      //console.log(data);
      let headerEndUsers = [
        'idEndUser',
        'endUserName',
        'idCustomer',
        'customerName',
        'serviceArea',
        'country',
        'status',
        'rebateProgram',
      ];
      //let dataBody = [];
      const dataXlsx = data.map((item) => {
        return {
          idEndUser: item.idEndUser,
          endUserName: item.endUserName,
          idCustomer: item.idCustomer,
          customerName: item.customerName,
          serviceArea: item.serviceArea,
          country: item.country,
          status: item.status,
          rebateProgram: item.rebateProgram,
        };
      });
      const ws = XLSX.utils.json_to_sheet(dataXlsx, { header: headerEndUsers });
      const wb = XLSX.utils.book_new();

      const date = moment(new Date()).format('YYYYMMDDHHmm');

      const filename = 'EndUser-' + date + '.xlsx';
      const ws_name = 'EnduserInfo';

      XLSX.utils.book_append_sheet(wb, ws, ws_name);
      XLSX.writeFile(wb, filename);

      this.setState({
        loadingExport: false,
      });
    }, 750);
  };

  render() {
    return (
      <div className="row">
        <div className="col-12">
          {/* <Card> */}
          <div>
            <br />
            <h5>
              <Trans i18nKey="cost per print" /> -{' '}
              <Trans i18nKey="customer list" />
            </h5>
            <br />
            <div>
              <div style={{ display: 'inline-block', marginRight: '12px' }}>
                {this.renderChannelsList(this.state.channels)}
              </div>
              <div style={{ display: 'inline-block' }}>
                {this.renderStatusList()}
              </div>
            </div>
            <br></br>

            <div style={{ backgroundColor: '#f2f2f2', padding: '0.5%' }}>
              {this.renderEndUsersTable()}
            </div>
            <br></br>
          </div>
          {/* </Card> */}
        </div>
      </div>
    );
  }
}

export default withTranslation()(Report);
